export interface Voicemail {
    id: number;
    blobName?: string;
    received?: Date;
    transcript?: string;
    triagedTo?: number | null;  // Team ID (references Teams.Id)
    triaged?: Date;
    triagedBy?: string;
    completed?: Date;
    completedBy?: string;
    patientId?: number;
    team?: string;  // Team name from JOIN
    phoneNumber?: string;
}

export interface VoicemailGroupCount {
    triagedTo?: number | null;
    teamName?: string;
    voicemailCount?: number;
}

export class Voicemail {
    constructor(obj?: Voicemail) {
        if (obj) Object.assign(this, obj);
    }
}
